<template>

    <b-modal
        id="assign-games-modal"
        size="sm"
        title="Przypisz gry"
        ok-title="Zapisz"
        cancel-title="Anuluj"
        ok-variant="success"
        no-close-on-backdrop
        @ok="assignGamesModalHandleOk"
        @hidden="assignGamesModalHandleHide">
        <form @submit.prevent="submitAssignGamesForm" @keydown="form.errors.clear($event.target.name)" ref="assign-games-form">

            <span style="font-size: 0.875rem;">Wybrane gry:</span>
            <ul class="mb-4">
                <li v-for="inputIdentificationName in this.form.input_identification_names">{{ inputIdentificationName }}</li>
            </ul>

            <div class="form-group">
                <label for="game_location">Położenie</label>
                <select class="form-control" id="game_location" v-model="form.set_id">
                    <option :value="null" disabled selected>Wybierz</option>
                    <option v-for="location in setLocations" :value="location.id">{{ location.text }}</option>
                </select>
                <span class="error mt-2 text-danger" v-if="form.errors.has('set_id')" v-text="form.errors.get('set_id')"></span>
            </div>

            <p>Nazwy wyświetlane dla przypisywanych elementów zostaną wygenerowane automatycznie na podstawie ostatnich członów identyfikatorów źródłowych.</p>

        </form>
    </b-modal>

</template>

<script>
    export default {

        name: 'GameLibraryAssignGamesModal',

        props: [
            'repo',
            'library',
            'setLocations'
        ],

        data() {
            return {
                eventHub: window.eventHub,
                form: new Vue.prototype.Form({
                    input_identification_names: [],
                    set_id: null
                })
            }
        },

        mounted() {

            // Set variables and show modal in add state
            this.eventHub.$on('game-library-assign-games', (inputIdentificationNames, setId = null) => {
                this.form = new Vue.prototype.Form({
                    input_identification_names: inputIdentificationNames,
                    set_id: setId
                });
                this.$bvModal.show('assign-games-modal');
            });

        },

        methods: {

            assignGamesModalHandleOk(event) {
                event.preventDefault();
                this.submitAssignGamesForm();
            },

            assignGamesModalHandleHide() {
                this.form = new Vue.prototype.Form({
                    input_identification_names: [],
                    set_id: null,
                });
            },

            submitAssignGamesForm() {
                this.eventHub.$emit('processing-start');
                this.form.post(route('game::game-library.store-games', {repo: this.repo}))
                    .then(response => {
                        this.eventHub.$emit('game-library-updated', response.data.library);
                        this.$bvModal.hide('assign-games-modal');
                        this.form.setData({
                            input_identification_names: [],
                            set_id: null
                        });
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', response.message, 'success');
                    })
                    .catch(error => {
                        console.log(error);
                        this.eventHub.$emit('processing-finish');
                        this.eventHub.$emit('toast-notification', 'Coś poszło nie tak. Sprawdź poprawność danych.', 'error');
                    });

            }

        }

    }
</script>

<style scoped>

</style>
